import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'List',
      component: () => import('@/views/List.vue') //小贴士列表
    },
    {
      path: '/list-detail/:id',
      name: 'ListDetail',
      component: () => import('@/views/ListDetail.vue') //列表详情
    },
  ]
})
